<template>
  <v-container fluid>
    <v-row>
      <v-col cols="2">
        <v-select
          :items="years"
          v-model="query.year"
          label="銷售年度"
          required
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          :items="months"
          v-model="query.month"
          label="銷售月份"
          required
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-btn color="primary" small class="mr-2" @click="displayChart">
          顯示銷售圖表
        </v-btn>
        <v-btn color="primary" small class="mr-2" @click="downloadReport">
          下載銷售月報表
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <highcharts :options="getChartOptions"></highcharts>
      </v-col>
    </v-row>
    <p>{{ message }}</p>
  </v-container>
</template>
<script>
import ChartDataService from "../../services/ChartDataService";
import ExportDataService from "../../services/ExportDataService";

export default {
  data() {
    return {
      query: {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
      },
      chartOptions: null,
      series: [], //資料，區分出各產品業務員的銷售資料
      categories: [], //類別，列出產品資料
      colors: [],
      colorCounter: 0,
      message: "",
      chart_title: "",
      years: [
        2025,
        2024,
        2023,
        2022,
        2021,
        2020,
        2019,
        2018,
        2017,
        2016,
        2015,
        2014,
        2013,
        2012,
        2011,
        2010,
      ],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  computed: {
    getChartOptions() {
      return {
        chart: {
          type: "column",
          height: (9 / 16) * 100 - 5 + "%",
        },
        colorCounter: this.colorCounter,
        colors: this.colors,
        title: {
          text: this.chart_title,
          align: "left",
          style: {
            fontSize: "24px",
            fontWeight: "bold",
            textAlign: "right",
            color: "#292929",
            padding: "8px",
          },
        },
        xAxis: {
          //X軸
          categories: this.categories,
          labels: {
            style: {
              fontSize: "15px",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "銷售金額",
            style: {
              fontSize: "15px",
            },
          },
          stackLabels: {
            enabled: true,
          },
          labels: {
            style: {
              fontSize: "15px",
            },
          },
        },
        legend: {
          align: "right",
          x: -30,
          verticalAlign: "top",
          y: -24,
          floating: true,
          backgroundColor: "white",
          borderColor: "#CCC",
          borderWidth: 0,
          shadow: false,
          itemStyle: {
            font: "16pt Trebuchet MS, Verdana, sans-serif",
            color: "#A0A0A0",
          },
          padding: 24,
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: this.series,
      };
    },
  },
  methods: {
    displayChart() {
      ChartDataService.getSalesAnalysisData(this.query.year, this.query.month)
        .then((result) => {
          this.message = result.message;
          var analysis_list = new Array();
          //保險產品合計金額
          result.data.products.forEach(function(product) {
            var amount_array = new Array(result.data.sales.length); //依業務員個數決定Array個數
            amount_array.fill(null); //預設填null，無資料時就不會顯示
            var analysis_item = {
              name: product,
              data: amount_array,
            };
            analysis_list.push(analysis_item);
          });

          //業務員銷售小計
          result.data.analysis.forEach(function(item) {
            const isMatch = (element) => element === item.sales_name;
            var sales_idx = result.data.sales.findIndex(isMatch);
            //console.log(item.sales_name)
            //console.log(sales_idx)

            item.details.forEach(function(detail) {
              const obj = analysis_list.find(
                (element) => element.name === detail.product
              );
              obj.data[sales_idx] += Math.round(detail.sub_amount * 100) / 100; //四捨五入到小數第二位
              //console.log(obj)
            });
          });

          this.colors = [];

          //依紅橙黃綠藍靛紫桃，深至淺配
          //https://www.wibibi.com/info.php?tid=372
          let color_defined_arr = [
            "#F50000",
            "#F59F00",
            "#F5F500",
            "#00F500",
            "#00F5F5",
            "#0000FA",
            "#9300FF",
            "#F700F7",
            "#FF5F5F",
            "#FFC14F",
            "#FFFF4F",
            "#4FFF4F",
            "#4FFFFF",
            "#4545FF",
            "#B54FFF",
            "#FFA1FF",
          ];

          for (var i = 0; i < result.data.products.length; i++) {
            this.colors.push(color_defined_arr[i]);
          }
          /* 隨機產顏色
                        var letters = '0123456789ABCDEF'
                        
                        result.data.products.forEach(function(){
                            var color = '#'
                            for (var j=0; j< 6; j++){
                                color += letters[Math.floor(Math.random() * 16)]
                            }
                            color_list.push(color)
                        })
                        */
          this.colorCounter = this.colors.length;
          //console.log(this.colors)

          this.series = analysis_list;
          this.categories = result.data.sales;
          this.chart_title =
            "保單銷售統計" + this.query.year + "年" + this.query.month + "月";
        })
        .catch(function(e) {
          console.log(e);
        });
    },
    downloadReport() {
      if (this.query.year == "" || this.query.month == "") {
        this.message = "請選擇銷售月份";
      } else {
        this.message = "下載銷售月報表";
        ExportDataService.exportSalesAnalysisReport(
          "excel",
          this.query.year,
          this.query.month
        );
      }
    },
  },
};
</script>
